// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__7YOKD","buttons":"RemoveExpirationActionButtons_buttons__2kCHn"};